import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const REQUEST_WORKSPACE_PRODUCT: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation requestProduct($input: RequestProductInput!) {
    requestProduct(input: $input) {
      workspaceProduct {
        id
        product
        status
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`
